import React, { Component } from 'react';
import { formatTime } from '../common/function';

class ForwardTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seconds: props.startTimeInSeconds || 0,
    };
    this.timer = null;
  }

  componentDidMount() {
    if (typeof this.props.onTick === 'function') {
      this.props.onTick(this.state.seconds);
    }

    if (this.props.isRunning) {
      this.startTimer();
    }
  }

  componentDidUpdate(prevProps) {
    // Update time if start time changed
    if (prevProps.startTimeInSeconds !== this.props.startTimeInSeconds) {
      this.setState({ seconds: this.props.startTimeInSeconds || 0 }, () => {
        if (typeof this.props.onTick === 'function') {
          this.props.onTick(this.state.seconds);
        }
      });
    }

    // Handle isRunning change
    if (prevProps.isRunning !== this.props.isRunning) {
      if (this.props.isRunning) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  startTimer = () => {
    if (!this.timer) {
      this.timer = setInterval(() => {
        this.setState(
          (prevState) => ({ seconds: prevState.seconds + 1 }),
          () => {
            if (typeof this.props.onTick === 'function') {
              this.props.onTick(this.state.seconds);
            }
          },
        );
      }, 1000);
    }
  };

  stopTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  render() {
    const { seconds } = this.state;
    const { isRunning, validated } = this.props;

    return (
      <div>
        <div className='timer_outer'>
          <i className='fa fa-clock-o' />
          <span className='timer_box'>{formatTime(seconds)}</span>
        </div>
        <button
          type='button'
          aria-label={isRunning ? 'Pause timer' : 'Resume timer'}
          className={`pause_btn icon-control-${isRunning ? 'pause' : 'play'}`}
          onClick={this.props.toggleTimer}
          disabled={validated}
        ></button>
      </div>
    );
  }
}

export default ForwardTimer;



// WEBPACK FOOTER //
// ./src/Components-2025/ForwardTimer.js